import React from 'react'
import {
  Drawer,
  DrawerHeader,
  DrawerContent,
  useDisclosure, Text,
} from '@chakra-ui/react'

type Props = {
  title?: string
  variant?: string
  children: React.ReactNode
}

const FooterDrawer: React.FC<Props> = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Text
        className={"cursor-pointer"}
        fontFamily={"lato"}
        fontWeight={"medium"}
        fontSize={18}
        color={"neutral-600"}
        onClick={onOpen}
      >
        {props.title}
      </Text>
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        size={['full', 'full', 'lg', 'xl', 'xl', 'xl']}
      >
        {/*<DrawerOverlay />*/}
        <DrawerHeader>
          {props.title}
        </DrawerHeader>
        <DrawerContent
          scrollBehavior={"smooth"}
          fontFamily={"lato"}
          fontWeight={"medium"}
          color={"red"}
        >
          {props.children}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default FooterDrawer
